module.exports = __webpack_public_path__ + "media/images/common/cart_btn_ov-25e53a81e3209e47587401a605099728.gif";